import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", null, "Uute pakkumiste lisamine", -1)
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-12" }
const _hoisted_4 = {
  key: 0,
  class: "text-danger validation-summary-errors",
  "data-valmsg-summary": "true"
}
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 control-label" }, "Müügikoht", -1)
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "col-4 p-2 control-label" }, "Kategooria", -1)
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 control-label" }, "URL (json,csv,xml)", -1)
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 control-label" }, "Kopeeri/kleebi vabatekstina", -1)
const _hoisted_15 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isAuthenticated)
      ? (_openBlock(), _createBlock(_component_Header, {
          key: 0,
          title: "",
          back: "home"
        }))
      : _createCommentVNode("", true),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.errorMsg != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, _toDisplayString(_ctx.errorMsg), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _withDirectives(_createElementVNode("select", {
            class: "col-sm-2",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.storeId) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getShopList(), (option) => {
              return (_openBlock(), _createElementBlock("option", {
                key: option.id,
                value: option.id
              }, _toDisplayString(option.name), 9, _hoisted_7))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.storeId]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _withDirectives(_createElementVNode("select", {
            class: "col-8",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.categoryId) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getCategoryList(), (option) => {
              return (_openBlock(), _createElementBlock("option", {
                key: option.id,
                value: option.id
              }, _toDisplayString(option.name), 9, _hoisted_10))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.categoryId]
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.url) = $event))
          }, null, 512), [
            [_vModelText, _ctx.url]
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.listDataString) = $event)),
            class: "form-control",
            style: {"min-width":"100%"}
          }, null, 512), [
            [_vModelText, _ctx.listDataString]
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("input", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.submitClicked())),
              type: "submit",
              value: "Import",
              class: "btn btn-primary"
            })
          ])
        ])
      ])
    ])
  ], 64))
}